import { GenericSmartViewsListWebComponent } from './component/GenericSmartViewsListWebComponent';
import { WEB_COMPONENT_GENERIC_SMART_VIEWS_LIST } from '../../webcomponents.constants';

export { GenericSmartViewsListWebComponent };

window.customElements.define(WEB_COMPONENT_GENERIC_SMART_VIEWS_LIST, GenericSmartViewsListWebComponent);
